import { AuthDomain, api } from 'auth-lib-front';
import { useMemo } from 'react';

import Project = AuthDomain.Object.Project;

/**
 * プロジェクト内のメンバー一覧から `memberId -> 表示名` の Map を返す共通フック。
 * 一覧画面の「作成者」「最終更新者」列など、ユーザー ID を表示名に変換したい用途で利用する。
 */
export function useMemberNameById(projectId: Project.Id): Map<string, string> {
  const { members } = api.useMember.ListInProject({ projectId });
  return useMemo(() => {
    const m = new Map<string, string>();
    for (const member of members) {
      m.set(member.id, member.name);
    }
    return m;
  }, [members]);
}
